import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { fontSizes } from 'syf-component-library/defaultTheme';
import ModalFooter from 'syf-component-library/ui/patterns/SlideInModal/Footer';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { Inset } from 'syf-component-library/ui/spacing';
import Stack from 'syf-component-library/ui/spacing/Stack/Stack';
import { Body, H4 } from 'syf-component-library/ui/typography';
import { DATA_OBJECT, DATA_TYPE } from '../../../../const/analytics';
import { autopayErrorImage } from '../../../../const/assets';
import { AUTOPAY_ERROR_TYPE_NAMES } from '../../../../const/machines';
import MainContext from '../../../../Context';
import usePaymentFlowMachine from '../../../../hooks/machines/usePaymentFlowMachine';
import { useIsErrorView } from '../../../../store/multiPaymentAtoms';
import { t } from '../../../../strings/i18n';
import { PaymentModalWrapper } from '../../../../ui/atoms/styled';
import { Card, PaymentDetailsRow } from '../subcomponents';
const Heading = styled(H4) `
  margin: 0px;
  font-size: ${fontSizes.medium}px;
  padding: 0px 14px;
  line-height: 32px;
`;
const Image = styled('img') `
  width: fill;
`;
const getErrorHeading = (errorType) => {
    const errorTitles = {
        [AUTOPAY_ERROR_TYPE_NAMES.ENROLLING]: 'autopayEnrollment',
        [AUTOPAY_ERROR_TYPE_NAMES.UPDATING]: 'autopayUpdate',
        [AUTOPAY_ERROR_TYPE_NAMES.UNENROLLING]: 'autopayUnenrollment'
    };
    return errorTitles[errorType];
};
const getDataReason = (errorType) => {
    const reasons = {
        [AUTOPAY_ERROR_TYPE_NAMES.ENROLLING]: 'autopay enrollment',
        [AUTOPAY_ERROR_TYPE_NAMES.UPDATING]: 'autopay update',
        [AUTOPAY_ERROR_TYPE_NAMES.UNENROLLING]: 'autopay unenroll'
    };
    return reasons[errorType];
};
const AutopayError = () => {
    const { staticHostName } = useContext(MainContext);
    const [, autopayActor, sendToAutopayMachine] = usePaymentFlowMachine();
    const { hasPaymentMethodBusinessValidationError, errorType } = autopayActor.context;
    const [, setIsErrorView] = useIsErrorView();
    const handlePrimaryButton = () => sendToAutopayMachine({ type: 'CANCEL' });
    useEffect(() => {
        setIsErrorView(true);
    }, [setIsErrorView]);
    return (_jsxs(_Fragment, { children: [_jsxs(PaymentModalWrapper, Object.assign({ bottom: "xlarge", hideOnBreakpointDown: "medium", top: "large", vertical: "large" }, { children: [_jsx(Stack, { size: "xlarge" }), _jsx(Card, Object.assign({ weight: "bold" }, { children: _jsxs(Inset, Object.assign({ hideOnBreakpointDown: "medium", horizontal: "large" }, { children: [_jsx(PaymentDetailsRow, Object.assign({ centerChildren: true, centerText: true }, { children: _jsx(Image, { alt: "", "aria-hidden": "true", src: `${staticHostName}${autopayErrorImage}` }) })), _jsx(Stack, { size: "large" }), _jsx(PaymentDetailsRow, Object.assign({ centerChildren: true, centerText: true }, { children: _jsx(Heading, Object.assign({ "data-cy": "autopay-error-heading", weight: "bold" }, { children: t(`errors.${getErrorHeading(errorType)}`) })) })), _jsx(Stack, { size: "small" }), _jsx(PaymentDetailsRow, Object.assign({ centerChildren: true, centerText: true }, { children: _jsx(Body, { children: _jsx(Inset, Object.assign({ "data-cy": "autopay-error-description", vertical: "xlarge" }, { children: hasPaymentMethodBusinessValidationError
                                                ? t('errors.invalidAlternatePaymentMethod')
                                                : t('errors.autopayErrorInstructions') })) }) }))] })) }))] })), _jsx(FooterContainer, { children: _jsx(ModalFooter, { dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: `${getDataReason(errorType)}:close`, dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: handlePrimaryButton, primaryText: t('button.close') }) })] }));
};
export default AutopayError;
